"use client";

import benefitsSectionBg from "@/assets/landingPage/benefits/benefis-section-bg.png";
import cardBg1 from "@/assets/landingPage/benefits/benefits-card-bg-1.png";
import cardBg2 from "@/assets/landingPage/benefits/benefits-card-bg-2.png";
import cardBg3 from "@/assets/landingPage/benefits/benefits-card-bg-3.png";
import cardBg4 from "@/assets/landingPage/benefits/benefits-card-bg-4.png";
import cardBg5 from "@/assets/landingPage/benefits/benefits-card-bg-5.png";
import cardBg6 from "@/assets/landingPage/benefits/benefits-card-bg-6.png";
import { useDocumentDirection } from "@/hooks/useDocumentDirection";
import { parseColorTextToJSX } from "@/utils/utils";
import Image from "next/image";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import TextReveal from "../animation/TextReveal";

const Benefits = ({ data, benefits }) => {
  const dir = useDocumentDirection();

  const cardBg = [
    { id: 1, bgImg: cardBg1 },
    { id: 2, bgImg: cardBg2 },
    { id: 3, bgImg: cardBg3 },
    { id: 4, bgImg: cardBg4 },
    { id: 5, bgImg: cardBg5 },
    { id: 6, bgImg: cardBg6 },
  ];

  return (
    <div
      className="benefits-section section_space_py no-repeat bg-cover w-full h-full overflow-hidden"
      style={{ backgroundImage: `url(${benefitsSectionBg.src})` }}
    >
      <div className="custom-container mx-auto">
        <div className="title-sec title_mb">
          <TextReveal delay={0.2} duration={1.2} direction="left">
            <h2 className="title-design">{parseColorTextToJSX(data?.title)}</h2>
          </TextReveal>
        </div>
        <div className="benefits-slider rtl:ml-0 md:rtl:-ml-[325px] ltr:mr-0 md:ltr:-mr-[325px]">
          <Swiper
            key={dir}
            dir={dir}
            // rtl={dir === "rtl"}
            spaceBetween={16}
            slidesPerView={1.2}
            pagination={{ clickable: true }}
            modules={[Pagination, Autoplay]}
            breakpoints={{
              320: { slidesPerView: 1, spaceBetween: 10 },
              576: { slidesPerView: 2.5, spaceBetween: 20 },
              768: { slidesPerView: 2.5, spaceBetween: 20 },
              992: { slidesPerView: 3.2, spaceBetween: 30 },
              1200: { slidesPerView: 3.5, spaceBetween: 30 },
              1400: { slidesPerView: 4.5, spaceBetween: 30 },
              1600: { slidesPerView: 4.8, spaceBetween: 30 },
              1920: { slidesPerView: 4.8, spaceBetween: 30 },
            }}
          >
            {benefits.map((benefit, index) => {
              const bg = cardBg[index % cardBg.length];

              return (
                <SwiperSlide key={benefit.id}>
                  <TextReveal
                    delay={0.1 * (index + 1)}
                    duration={1}
                    direction="bottom"
                  >
                    <div
                      className="benefit-card bg-cover w-full h-full p-6 rounded-xl"
                      style={{ backgroundImage: `url(${bg.bgImg.src})` }}
                    >
                      <p className="text-xl font-semibold">{benefit?.title}</p>
                      <div className="w-[60px] h-[60px] my-[30px] md:my-[40px] lg:my-[50px]">
                        <Image
                          src={benefit.icon}
                          alt={benefit.title}
                          width={100}
                          height={100}
                          unoptimized
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <p className="paragraph-design">{benefit?.description}</p>
                    </div>
                  </TextReveal>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default Benefits;
